import React from 'react';
import { Flex, Square } from '@grubhubprod/gh-cookbook-react';

export const DataTableTitleBar: React.FC = ({ children }) => (
  <Square
    inset="md"
    borderBottom="1px solid"
    borderColor="lightLine"
    borderTopLeftRadius="4px"
    borderTopRightRadius="4px"
  >
    <Flex alignItems="center">{children}</Flex>
  </Square>
);
